<div class="container">
  <p>
    Please follow the instructions for vendor information change request form
    below.
  </p>

  <div
    class="request-status-note"
    *ngIf="Status && Status !== 'No Request found'"
  >
    <p>
      <span>Request Status:</span>
      <span
        [ngClass]="{
          'status-in-progress': Status === 'Your Request is In progress',
          'status-completed': Status === 'Your Request is Completed',
          'status-denied': Status === 'Your Request was Denied',
          'status-inactive': Status === 'Your Request is Inactive',
        }"
        [style.color]="
          Status === 'Your Request is In progress'
            ? 'lightcoral'
            : Status === 'Your Request is Completed'
              ? 'green'
              : Status === 'Your Request was Denied'
                ? 'red'
                : Status === 'Your Request is Inactive'
                  ? 'orange'
                  : 'inherit'
        "
      >
        {{ Status }}
      </span>
      <span *ngIf="Status === 'Your Request is Completed'">
        <span> | Completion Date:</span> {{ CompletionDate }}
      </span>
    </p>
  </div>
  <form novalidate [formGroup]="form" class="form-horizontal">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label class="inline"
            >Vendor Name <span class="text-danger">*</span></label
          >
          <div
            class="form-group"
            [ngClass]="{ 'has-error ': !f['Name'].valid && submitted }"
          >
            <input type="text" class="form-control" formControlName="Name" />
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label class="inline"
            >Legal Entity Name <span class="text-danger">*</span></label
          >
          <div
            class="form-group"
            [ngClass]="{ 'has-error': f['LegalName'].invalid && submitted }"
          >
            <input
              type="text"
              class="form-control"
              formControlName="LegalName"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group col-12">
          <label class="inline">Goods and Services Description</label>
          <div
            class="form-group"
            [ngClass]="{ 'has-error': f['Description'].invalid && submitted }"
          >
            <textarea
              rows="2"
              class="form-control txt-area-height"
              formControlName="Description"
              maxlength="500"
            ></textarea>
            <div
              class="text-danger"
              *ngIf="submitted && f['Description'].errors?.['maxlength']"
            >
              Description cannot be more than 500 characters.
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <div
            type="button"
            class="accordion-header"
            (click)="toggleCollapse()"
          >
            <a class="collapse-toggle text-white">
              <span>Addresses ({{ vendorAddress.length }})</span>
              <i
                class="fa"
                [ngClass]="{
                  'fa-chevron-up': isCollapsed,
                  'fa-chevron-down': !isCollapsed,
                }"
                style="font-size: 18px"
              ></i>
            </a>
          </div>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <div class="col-md-12" [ngClass]="{ 'd-none': !isCollapsed }">
                <div id="accordionAddresses">
                  <div>
                    <div>
                      <div formArrayName="vendorAddresses">
                        <div
                          *ngFor="
                            let address of vendorAddress.controls;
                            let i = index
                          "
                          [formGroupName]="i"
                          class="address-section"
                        >
                          <hr />
                          <div
                            class="col-6"
                            *ngIf="
                              address.get('addressType')?.value ==
                              vendorAddressAndContactType.Remittance
                            "
                          >
                            <div class="form-check">
                              <input
                                type="checkbox"
                                formControlName="isSameAddress"
                                (change)="onSameAddressCheck(i)"
                                class="form-check-input"
                              />
                              <label class="form-check-label">
                                Remittance address is same as purchasing address
                                <span class="form-check-sign"></span>
                              </label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <label for="addressType">Address Type</label>
                              <div class="form-group">
                                <select
                                  class="form-control ddl-select form-select"
                                  formControlName="addressType"
                                  [ngClass]="{
                                    'has-error':
                                      submitted &&
                                      address.get('addressType')?.invalid,
                                    unselectable:
                                      address.get('isDefaultAddress')?.value,
                                  }"
                                >
                                  <option value="">-Select-</option>
                                  <option
                                    [value]="item.id"
                                    *ngFor="let item of addressAndContactTypes"
                                  >
                                    {{ item.name }}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <label for="address">
                                Address Line 1
                                <span class="text-danger">*</span></label
                              >
                              <div
                                class="form-group"
                                [ngClass]="{
                                  'has-error':
                                    submitted &&
                                    address.get('address')?.invalid,
                                }"
                              >
                                <input
                                  type="text"
                                  class="form-control"
                                  formControlName="address"
                                  placeholder="Enter address line 1"
                                  maxlength="50"
                                />
                                <span class="char-counter">
                                  {{
                                    address.get("address")?.value?.length || 0
                                  }}/50
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <label for="addressLine2">Address Line 2</label>
                              <div class="form-group">
                                <input
                                  type="text"
                                  class="form-control"
                                  formControlName="addressLine2"
                                  placeholder="Enter address line 2 (optional)"
                                  maxlength="50"
                                  [ngClass]="{
                                    'has-error':
                                      submitted &&
                                      address.get('addressLine2')?.invalid,
                                  }"
                                />
                                <span class="char-counter">
                                  {{
                                    address.get("addressLine2")?.value
                                      ?.length || 0
                                  }}/50
                                </span>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <label for="city"
                                >City <span class="text-danger">*</span></label
                              >
                              <div
                                class="form-group"
                                [ngClass]="{
                                  'has-error':
                                    submitted && address.get('city')?.invalid,
                                }"
                              >
                                <input
                                  type="text"
                                  class="form-control"
                                  formControlName="city"
                                  placeholder="Enter city"
                                  maxlength="30"
                                />
                                <span class="char-counter">
                                  {{
                                    address.get("city")?.value?.length || 0
                                  }}/30
                                </span>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-6">
                              <div class="form-check">
                                <input
                                  type="checkbox"
                                  formControlName="isInternational"
                                  (change)="onChangeInternationalAddress(i)"
                                  class="form-check-input"
                                />
                                <label class="form-check-label">
                                  I have an International Address
                                  <span class="form-check-sign"></span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div
                              class="col-md-6"
                              *ngIf="!address.get('isInternational')?.value"
                            >
                              <label for="state"
                                >State <span class="text-danger">*</span></label
                              >
                              <div
                                class="form-group"
                                [ngClass]="{
                                  'has-error':
                                    submitted && address.get('state')?.invalid,
                                }"
                              >
                                <select
                                  class="form-control ddl-select form-select"
                                  formControlName="state"
                                >
                                  <option>-Select State-</option>
                                  <option
                                    [value]="s.abbreviation"
                                    *ngFor="let s of usStates"
                                  >
                                    {{ s.name }}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div
                              class="col-md-6"
                              *ngIf="address.get('isInternational')?.value"
                            >
                              <label l for="state"> State</label>
                              <div
                                class="form-group"
                                [ngClass]="{
                                  'has-error':
                                    submitted && address.get('state')?.invalid,
                                }"
                              >
                                <input
                                  name="stateInput"
                                  formControlName="state"
                                  type="text"
                                  class="form-control"
                                  placeholder="Enter state"
                                />
                              </div>
                            </div>
                            <div
                              class="col-md-6"
                              *ngIf="!address.get('isInternational')?.value"
                            >
                              <label for="country"> Country</label>
                              <div
                                class="form-group"
                                [ngClass]="{
                                  'has-error':
                                    submitted &&
                                    address.get('country')?.invalid,
                                }"
                              >
                                <input
                                  name="countryReadOnly"
                                  readonly
                                  formControlName="country"
                                  type="text"
                                  class="form-control"
                                />
                              </div>
                            </div>
                            <div
                              class="col-md-6"
                              *ngIf="address.get('isInternational')?.value"
                            >
                              <label for="country"> Country</label>
                              <div
                                class="form-group"
                                [ngClass]="{
                                  'has-error':
                                    submitted &&
                                    address.get('country')?.invalid,
                                }"
                              >
                                <input
                                  name="country"
                                  formControlName="country"
                                  type="text"
                                  class="form-control"
                                />
                              </div>
                            </div>
                            <div class="col-md-6">
                              <label for="zipCode"
                                >{{
                                  address.get("isInternational")?.value
                                    ? "Postal Code"
                                    : "Zip Code"
                                }}
                                <span class="text-danger">*</span></label
                              >
                              <span
                                class="zip-info-icon"
                                tabindex="0"
                                role="img"
                                [attr.aria-label]="
                                  address.get('isInternational')?.value
                                    ? 'Enter up to 10 characters. Letters, numbers, spaces and \'-\' are allowed.'
                                    : 'Enter up to 5 digits, optionally followed by a hyphen and 4 digits (ZIP plus 4). Numbers and \'-\' only.'
                                "
                              >
                                <i
                                  class="fa fa-info-circle"
                                  aria-hidden="true"
                                ></i>
                                <span class="zip-tooltip">
                                  {{
                                    address.get("isInternational")?.value
                                      ? "Postal code accepts letters, numbers, spaces and '-'."
                                      : "ZIP accepts 5 digits, or 5 digits + hyphen + 4 digits. Numbers and '-' only."
                                  }}
                                </span>
                              </span>
                              <div
                                class="form-group"
                                [ngClass]="{
                                  'has-error':
                                    submitted &&
                                    address.get('zipCode')?.invalid,
                                }"
                              >
                                <input
                                  type="text"
                                  class="form-control"
                                  formControlName="zipCode"
                                  [placeholder]="
                                    address.get('isInternational')?.value
                                      ? 'Enter postal code'
                                      : 'Enter zip code'
                                  "
                                  maxlength="10"
                                  [attr.pattern]="
                                    address.get('isInternational')?.value
                                      ? '^[a-zA-Z0-9 -]*$'
                                      : '^[0-9-]*$'
                                  "
                                  (input)="
                                    onZipInput(
                                      address.get('zipCode'),
                                      !!address.get('isInternational')?.value
                                    )
                                  "
                                />
                                <span class="char-counter">
                                  {{
                                    address.get("zipCode")?.value?.length || 0
                                  }}/10
                                </span>
                              </div>
                            </div>
                          </div>
                          <div
                            class="row"
                            *ngIf="
                              address.get('addressType')?.value ==
                              vendorAddressAndContactType.Remittance
                            "
                          >
                            <div class="col-md-6">
                              <label [attr.for]="'customerAccountNumber-' + i"
                                >Customer Account Number</label
                              >
                              <div
                                class="form-group"
                                [ngClass]="{
                                  'has-error':
                                    submitted &&
                                    address.get('customerAccountNumber')?.invalid,
                                }"
                              >
                                <input
                                  type="text"
                                  class="form-control"
                                  formControlName="customerAccountNumber"
                                  [attr.id]="'customerAccountNumber-' + i"
                                  placeholder="Account number assigned to you by this vendor (optional)"
                                  maxlength="50"
                                />
                                <span class="char-counter">
                                  {{
                                    address.get("customerAccountNumber")?.value
                                      ?.length || 0
                                  }}/50
                                </span>
                              </div>
                            </div>
                          </div>
                          <button
                            *ngIf="!address.get('isDefaultAddress')?.value"
                            type="button"
                            class="post-tag"
                            (click)="removeAddress(i)"
                          >
                            Remove Address
                          </button>
                        </div>
                      </div>
                      <button
                        type="button"
                        class="post-tag"
                        (click)="addAddress()"
                      >
                        Add New Address
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label class="inline"
            >1099 Form Delivery Preference
            <span class="text-danger">*</span></label
          >
          <div
            class="form-group"
            [ngClass]="{
              'has-error': f['deliveryMethod'].invalid && submitted,
            }"
          >
            <select
              class="form-control form-select"
              formControlName="deliveryMethod"
            >
              <option value="Email">Email</option>
              <option value="Mail">Mail</option>
              <option value="EmailAndMail">Email and Mail</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label
            [ngClass]="{ 'text-danger': f['W9Status'].invalid && submitted }"
            >W-9 Applicable? <span class="required">*</span></label
          >&nbsp;&nbsp;
          <div class="form-group row">
            <div class="form-check-radio col-md-6 pad-desktop">
              <label
                class="form-check-label"
                [ngClass]="{
                  'text-danger': f['W9Status'].invalid && submitted,
                }"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  formControlName="W9Status"
                  id="W9Status"
                  value="Yes"
                  (change)="onW9StatusChanged()"
                />
                Yes <span class="form-check-sign"></span> </label
              >&nbsp;&nbsp;
            </div>
            <div class="form-check-radio col-md-6 pad-desktop">
              <label
                class="form-check-label"
                [ngClass]="{
                  'text-danger': f['W9Status'].invalid && submitted,
                }"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  formControlName="W9Status"
                  id="W9StatusNo"
                  value="No"
                  (change)="onW9StatusChanged()"
                />
                No <span class="form-check-sign"></span> </label
              >&nbsp;&nbsp;
            </div>
          </div>
        </div>
        <div>
          <div class="form-group">
            <label
              [ngClass]="{
                'text-danger':
                  f['ApplicableTaxIdentificationNumber'].invalid && submitted,
              }"
              >Applicable Tax Identification Number (TIN)
              <span class="required">*</span></label
            >&nbsp;&nbsp;
            <div class="form-group row">
              <div class="form-check-radio col-md-6 pad-desktop">
                <label
                  class="form-check-label"
                  [ngClass]="{
                    'text-danger':
                      f['ApplicableTaxIdentificationNumber'].invalid &&
                      submitted,
                  }"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="ApplicableTaxIdentificationNumber"
                    id="TIN-EIN"
                    value="Employer Identification Number"
                    [disabled]="true"
                  />
                  EIN <span class="form-check-sign"></span> </label
                >&nbsp;&nbsp;
              </div>
              <div class="form-check-radio col-md-6 pad-desktop">
                <label
                  class="form-check-label"
                  [ngClass]="{
                    'text-danger':
                      f['ApplicableTaxIdentificationNumber'].invalid &&
                      submitted,
                  }"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="ApplicableTaxIdentificationNumber"
                    id="TIN_SSN"
                    value="Social Security Number"
                    [disabled]="true"
                  />
                  SSN <span class="form-check-sign"></span> </label
                >&nbsp;&nbsp;
              </div>
            </div>
            <div class="tin-info-box">
              <i class="fa fa-info-circle"></i>
              <span
                >Changes to your TIN require a separate vendor profile. If your
                TIN has changed, please submit a New Vendor Registration through
                the portal.</span
              >
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="form-group">
            <label
              [ngClass]="{
                'text-danger': f['IsIncorporated'].invalid && submitted,
              }"
              >Vendor is Incorporated? </label
            >&nbsp;&nbsp;
            <div class="form-group row">
              <div class="form-check-radio col-md-6 pad-desktop">
                <label
                  class="form-check-label"
                  [ngClass]="{
                    'text-danger': f['IsIncorporated'].invalid && submitted,
                  }"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="IsIncorporated"
                    id="IsIncorporatedYes"
                    value="Yes"
                    (change)="incorporatedChange()"
                  />
                  Yes <span class="form-check-sign"></span> </label
                >&nbsp;&nbsp;
              </div>
              <div class="form-check-radio col-md-6 pad-desktop">
                <label
                  class="form-check-label"
                  [ngClass]="{
                    'text-danger': f['IsIncorporated'].invalid && submitted,
                  }"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="IsIncorporated"
                    id="IsIncorporatedNo"
                    value="No"
                    (change)="incorporatedChange()"
                  />
                  No <span class="form-check-sign"></span> </label
                >&nbsp;&nbsp;
              </div>
            </div>
          </div>

          <div
            [hidden]="
              form.get('IsIncorporated')?.value == 'No' ||
              form.get('IsIncorporated')?.value == null
            "
          >
            <label
              [ngClass]="{
                'text-danger': f['corporationType'].invalid && submitted,
              }"
              >Type of Corporation <span class="required">*</span> </label
            >&nbsp;&nbsp;
            <div class="form-group row">
              <div class="form-check-radio col-md-6 pad-desktop">
                <label
                  class="form-check-label inline"
                  [ngClass]="{
                    'text-danger': f['corporationType'].invalid && submitted,
                  }"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="corporationType"
                    id="corporationType-C"
                    value="C-Corporation"
                  />
                  C-Corporation <span class="form-check-sign"></span> </label
                >&nbsp;&nbsp;
              </div>
              <div class="form-check-radio col-md-6 pad-desktop">
                <label
                  class="form-check-label"
                  [ngClass]="{
                    'text-danger': f['corporationType'].invalid && submitted,
                  }"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="corporationType"
                    id="corporationType_S"
                    value="S-Corporation"
                  />
                  S-Corporation <span class="form-check-sign"></span> </label
                >&nbsp;&nbsp;
              </div>
            </div>
          </div>

          <div class="form-group">
            <label
              [ngClass]="{
                'text-danger': f['TradeBusinessEngaged'].invalid && submitted,
              }"
              >Engaged in a Trade or Business? </label
            >&nbsp;&nbsp;
            <div class="form-group row">
              <div class="form-check-radio col-md-6 pad-desktop">
                <label
                  class="form-check-label"
                  [ngClass]="{
                    'text-danger':
                      f['TradeBusinessEngaged'].invalid && submitted,
                  }"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="TradeBusinessEngaged"
                    id="TradeBusinessEngagedYes"
                    value="true"
                  />
                  Yes <span class="form-check-sign"></span> </label
                >&nbsp;&nbsp;
              </div>
              <div class="form-check-radio col-md-6 pad-desktop">
                <label
                  class="form-check-label"
                  [ngClass]="{
                    'text-danger':
                      f['TradeBusinessEngaged'].invalid && submitted,
                  }"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="TradeBusinessEngaged"
                    id="TradeBusinessEngagedNo"
                    value="false"
                  />
                  No <span class="form-check-sign"></span> </label
                >&nbsp;&nbsp;
              </div>
            </div>
          </div>

          <div class="form-group">
            <label
              [ngClass]="{
                'text-danger':
                  f['MedicalLegalServicesStatus'].invalid && submitted,
              }"
              >Provides Medical or Legal Services</label
            >&nbsp;&nbsp;
            <div class="form-group row">
              <div class="form-check-radio col-md-6 pad-desktop">
                <label
                  class="form-check-label"
                  [ngClass]="{
                    'text-danger':
                      f['MedicalLegalServicesStatus'].invalid && submitted,
                  }"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="MedicalLegalServicesStatus"
                    id="MedicalLegalServicesStatusYes"
                    value="Yes"
                    (change)="form1099ApplicableAutoPopulate()"
                  />
                  Yes <span class="form-check-sign"></span> </label
                >&nbsp;&nbsp;
              </div>
              <div class="form-check-radio col-md-6 pad-desktop">
                <label
                  class="form-check-label"
                  [ngClass]="{
                    'text-danger':
                      f['MedicalLegalServicesStatus'].invalid && submitted,
                  }"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="MedicalLegalServicesStatus"
                    id="MedicalLegalServicesStatusNo"
                    value="No"
                    (change)="form1099ApplicableAutoPopulate()"
                  />
                  No <span class="form-check-sign"></span> </label
                >&nbsp;&nbsp;
              </div>
            </div>
          </div>

          <div
            [hidden]="
              form.get('MedicalLegalServicesStatus')?.value == 'No' ||
              form.get('MedicalLegalServicesStatus')?.value == null
            "
          >
            <div class="col-12">
              <div class="form-group">
                <label class="inline">1099-MISC Primary Payment Type</label>
                <div
                  class="form-group"
                  [ngClass]="{
                    'has-error': f['paymentType'].invalid && submitted,
                  }"
                >
                  <select
                    class="form-control form-select"
                    formControlName="paymentType"
                  >
                    <option value="0">- Select Payment Type -</option>
                    <option value="B1Rents">Rent</option>
                    <option value="B2Royalties">Royalties</option>
                    <option value="B5FishingBoatProceeds">
                      Fishing Boat Proceeds
                    </option>
                    <option value="B6MedHealthcarePymts">
                      Medical Healthcare Payments
                    </option>
                    <option value="B9CropInsurance">Crop Insurance</option>
                    <option value="B10GrossProceeds">
                      Gross Proceeds paid to an Attorney
                    </option>
                    <option value="B11FishPurForResale">
                      Fish Purchased for Resale
                    </option>
                    <option value="B8SubstitutePymts">
                      Substitute Payments
                    </option>
                    <option value="B3OtherIncome">Other</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label
              [ngClass]="{ 'text-danger': f['PayViaACH'].invalid && submitted }"
              >Would You Like To Be Paid Electronically Via ACH
              <span class="required">*</span></label
            >&nbsp;&nbsp;
            <div class="form-group row">
              <div class="form-check-radio col-md-6 pad-desktop">
                <label
                  class="form-check-label"
                  [ngClass]="{
                    'text-danger': f['PayViaACH'].invalid && submitted,
                  }"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="PayViaACH"
                    id="PayViaACHYes"
                    value="true"
                  />
                  Yes <span class="form-check-sign"></span> </label
                >&nbsp;&nbsp;
              </div>
              <div class="form-check-radio col-md-6 pad-desktop">
                <label
                  class="form-check-label"
                  [ngClass]="{
                    'text-danger': f['PayViaACH'].invalid && submitted,
                  }"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="PayViaACH"
                    id="PayViaACHNo"
                    value="false"
                  />
                  No <span class="form-check-sign"></span> </label
                >&nbsp;&nbsp;
              </div>
            </div>
          </div>

          <div class="form-group">
            <label
              [ngClass]="{
                'text-danger':
                  f['ReceivesRentOrRoyaltyIncome'].invalid && submitted,
              }"
              >Receives Rent or Royalty Income</label
            >&nbsp;&nbsp;
            <div class="form-group row">
              <div class="form-check-radio col-md-6 pad-desktop">
                <label
                  class="form-check-label"
                  [ngClass]="{
                    'text-danger':
                      f['ReceivesRentOrRoyaltyIncome'].invalid && submitted,
                  }"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="ReceivesRentOrRoyaltyIncome"
                    id="ReceivesRentOrRoyaltyIncomeYes"
                    value="true"
                  />
                  Yes <span class="form-check-sign"></span> </label
                >&nbsp;&nbsp;
              </div>
              <div class="form-check-radio col-md-6 pad-desktop">
                <label
                  class="form-check-label"
                  [ngClass]="{
                    'text-danger':
                      f['ReceivesRentOrRoyaltyIncome'].invalid && submitted,
                  }"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="ReceivesRentOrRoyaltyIncome"
                    id="ReceivesRentOrRoyaltyIncomeNo"
                    value="false"
                  />
                  No <span class="form-check-sign"></span> </label
                >&nbsp;&nbsp;
              </div>
            </div>
          </div>

          <div class="form-group">
            <label
              [ngClass]="{
                'text-danger':
                  f['MinorityBusinessEnterprise'].invalid && submitted,
              }"
            >
              MBE (Minority Business Enterprise) Certified </label
            >&nbsp;&nbsp;
            <div class="form-group row">
              <div class="form-check-radio col-md-6 pad-desktop">
                <label
                  class="form-check-label"
                  [ngClass]="{
                    'text-danger':
                      f['MinorityBusinessEnterprise'].invalid && submitted,
                  }"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="MinorityBusinessEnterprise"
                    id="MinorityBusinessEnterpriseYes"
                    value="true"
                  />
                  Yes <span class="form-check-sign"></span> </label
                >&nbsp;&nbsp;
              </div>
              <div class="form-check-radio col-md-6 pad-desktop">
                <label
                  class="form-check-label"
                  [ngClass]="{
                    'text-danger':
                      f['MinorityBusinessEnterprise'].invalid && submitted,
                  }"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="MinorityBusinessEnterprise"
                    id="MinorityBusinessEnterpriseNo"
                    value="false"
                  />
                  No <span class="form-check-sign"></span> </label
                >&nbsp;&nbsp;
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div
          [hidden]="
            form.get('W9Status')?.value == 'No' ||
            form.get('W9Status')?.value == null
          "
        >
          <div class="form-group">
            <div
              class="col-md-6 form-group file-upload-container"
              [ngClass]="{
                'has-error': f['vendorW9File'].invalid && submitted,
              }"
            >
              <client-purchasing-file-upload
                *ngIf="!isEditing"
                [labelName]="'Attach Vendor W-9 (max 10MB)'"
                [isRequired]="f['W9Status'].value == 'Yes'"
                [submitted]="submitted"
                [isValid]="f['vendorW9File'].valid && f['vendorW9File'].value"
                (fileValueChanged)="onFileChange($event, 'vendorW9File', 10)"
              >
              </client-purchasing-file-upload>
              <label *ngIf="hasVendorW9Attachment() as attachment">
                Previous Vendor W-9:
                <a
                  [href]="attachment?.linkUrl"
                  target="_blank"
                  class="btn-link"
                >
                  {{ attachment?.documentName }}
                </a></label
              >
            </div>
          </div>
        </div>
        <div
          [hidden]="
            form.get('ApplicableTaxIdentificationNumber')?.value !==
            'Employer Identification Number'
          "
        >
          <div class="form-group">
            <label
              >Employer Identification Number (EIN)
              <span class="required">*</span></label
            ><br />
            <div
              class="form-group"
              [ngClass]="{
                'has-error':
                  f['EmployerIdentificationNumber'].invalid && submitted,
              }"
            >
              <input
                type="text"
                class="form-control"
                mask="00-0000000"
                formControlName="EmployerIdentificationNumber"
                [disabled]="true"
              />
            </div>
          </div>
        </div>
        <div
          [hidden]="
            form.get('ApplicableTaxIdentificationNumber')?.value !==
            'Social Security Number'
          "
        >
          <div class="form-group">
            <label
              >Social Security Number (SSN)
              <span class="required">*</span></label
            ><br />
            <div
              class="form-group"
              [ngClass]="{
                'has-error': f['SocialSecurityNumber'].invalid && submitted,
              }"
            >
              <input
                type="text"
                class="form-control"
                mask="000-00-0000"
                formControlName="SocialSecurityNumber"
                [disabled]="true"
              />
            </div>
          </div>
        </div>

        <div [hidden]="form.get('W9Status')?.value == 'Yes'">
          <div class="form-group">
            <label>Reason<span class="text-danger">*</span></label
            ><br />
            <div
              class="form-group"
              [ngClass]="{
                'has-error': f['W9StatusReason'].invalid && submitted,
              }"
            >
              <input
                type="text"
                class="form-control"
                formControlName="W9StatusReason"
              />
            </div>
          </div>
        </div>

        <div class="form-group">
          <label
            [ngClass]="{ 'text-danger': f['VendorType'].invalid && submitted }"
            >Vendor Type</label
          >&nbsp;&nbsp;
          <div class="form-group row">
            <div class="form-check-radio col-md-6 pad-desktop">
              <label
                class="form-check-label"
                [ngClass]="{
                  'text-danger': f['VendorType'].invalid && submitted,
                }"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  formControlName="VendorType"
                  id="VendorType-Active"
                  value="Active"
                />
                Active <span class="form-check-sign"></span> </label
              >&nbsp;&nbsp;
            </div>
            <div class="form-check-radio col-md-6 pad-desktop">
              <label
                class="form-check-label"
                [ngClass]="{
                  'text-danger': f['VendorType'].invalid && submitted,
                }"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  formControlName="VendorType"
                  id="VendorType-Prospective"
                  value="Prospective"
                />
                Prospective <span class="form-check-sign"></span> </label
              >&nbsp;&nbsp;
            </div>
          </div>
        </div>

        <div class="form-group">
          <label
            [ngClass]="{
              'text-danger': f['FutureBidStatus'].invalid && submitted,
            }"
            >Include on Future Bid Opportunities</label
          >&nbsp;&nbsp;
          <div class="form-group row">
            <div class="form-check-radio col-md-6 pad-desktop">
              <label
                class="form-check-label"
                [ngClass]="{
                  'text-danger': f['FutureBidStatus'].invalid && submitted,
                }"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  formControlName="FutureBidStatus"
                  id="FutureBidStatusYes"
                  value="Yes"
                />
                Yes <span class="form-check-sign"></span> </label
              >&nbsp;&nbsp;
            </div>
            <div class="form-check-radio col-md-6 pad-desktop">
              <label
                class="form-check-label"
                [ngClass]="{
                  'text-danger': f['FutureBidStatus'].invalid && submitted,
                }"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  formControlName="FutureBidStatus"
                  id="FutureBidStatusNo"
                  value="No"
                />
                No <span class="form-check-sign"></span> </label
              >&nbsp;&nbsp;
            </div>
          </div>
        </div>

        <div class="form-group">
          <label
            [ngClass]="{
              'text-danger':
                f['ProvidesMerchandiseOrUtilities'].invalid && submitted,
            }"
            >Provides Merchandise or Utilities</label
          >&nbsp;&nbsp;
          <div class="form-group row">
            <div class="form-check-radio col-md-6 pad-desktop">
              <label
                class="form-check-label"
                [ngClass]="{
                  'text-danger':
                    f['ProvidesMerchandiseOrUtilities'].invalid && submitted,
                }"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  formControlName="ProvidesMerchandiseOrUtilities"
                  id="ProvidesMerchandiseOrUtilitiesYes"
                  value="true"
                />
                Yes <span class="form-check-sign"></span> </label
              >&nbsp;&nbsp;
            </div>
            <div class="form-check-radio col-md-6 pad-desktop">
              <label
                class="form-check-label"
                [ngClass]="{
                  'text-danger':
                    f['ProvidesMerchandiseOrUtilities'].invalid && submitted,
                }"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  formControlName="ProvidesMerchandiseOrUtilities"
                  id="ProvidesMerchandiseOrUtilitiesNo"
                  value="false"
                />
                No <span class="form-check-sign"></span> </label
              >&nbsp;&nbsp;
            </div>
          </div>
        </div>

        <div class="form-group">
          <label
            [ngClass]="{
              'text-danger': f['ExistingBusinessRelation'].invalid && submitted,
            }"
            >Do you have any existing business relationship with the
            {{ utilityService.clientDisplayName }}’s Office or its
            employees?</label
          >&nbsp;&nbsp;
          <div class="form-group row">
            <div class="form-check-radio col-md-6 pad-desktop">
              <label
                class="form-check-label"
                [ngClass]="{
                  'text-danger':
                    f['ExistingBusinessRelation'].invalid && submitted,
                }"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  formControlName="ExistingBusinessRelation"
                  id="ExistingBusinessRelationYes"
                  value="true"
                />
                Yes <span class="form-check-sign"></span> </label
              >&nbsp;&nbsp;
            </div>
            <div class="form-check-radio col-md-6 pad-desktop">
              <label
                class="form-check-label"
                [ngClass]="{
                  'text-danger':
                    f['ExistingBusinessRelation'].invalid && submitted,
                }"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  formControlName="ExistingBusinessRelation"
                  id="ExistingBusinessRelationNo"
                  value="false"
                />
                No <span class="form-check-sign"></span> </label
              >&nbsp;&nbsp;
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      [hidden]="
        form.get('PayViaACH')?.value == 'false' ||
        form.get('PayViaACH')?.value == null
      "
    >
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Bank Name <span class="required">*</span></label
            >&nbsp;&nbsp;
            <div
              class="form-group"
              [ngClass]="{ 'has-error': f['BankName'].invalid && submitted }"
            >
              <input
                type="text"
                class="form-control"
                formControlName="BankName"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Bank Type <span class="required">*</span></label
            >&nbsp;&nbsp;
            <div
              class="form-group"
              [ngClass]="{
                'has-error': f['BankAccountClass'].invalid && submitted,
              }"
            >
              <select
                class="form-control form-select"
                formControlName="BankAccountClass"
              >
                <option value="1">PERSONAL</option>
                <option value="2">BUSINESS</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Account Type <span class="required">*</span></label
            >&nbsp;&nbsp;
            <div
              class="form-group"
              [ngClass]="{
                'has-error': f['BankAccountType'].invalid && submitted,
              }"
            >
              <select
                class="form-control form-select"
                formControlName="BankAccountType"
              >
                <option value="SAVINGS">SAVINGS</option>
                <option value="CHECKING">CHECKING</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Routing Number <span class="required">*</span></label
            >&nbsp;&nbsp;
            <div
              class="form-group"
              [ngClass]="{
                'has-error': f['BankRoutingNumber'].invalid && submitted,
              }"
            >
              <input
                type="text"
                class="form-control"
                formControlName="BankRoutingNumber"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Account Number <span class="required">*</span></label
            >&nbsp;&nbsp;
            <div
              class="form-group"
              [ngClass]="{
                'has-error': f['BankAccountNumber'].invalid && submitted,
              }"
            >
              <input
                type="text"
                class="form-control"
                formControlName="BankAccountNumber"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group file-upload-container">
            <client-purchasing-file-upload
              [labelName]="'Attach Voided Check (max 5MB)'"
              [submitted]="submitted"
              [isValid]="f['voidedCheckFile'].valid"
              (fileValueChanged)="onFileChange($event, 'voidedCheckFile', 5)"
            >
            </client-purchasing-file-upload>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="col-md-6">
          <button type="button" class="post-tag" (click)="fileInput.click()">
            <i class="pe-7s-plus"></i> Add Attachment/s (up to 30MB)
          </button>
          <input
            type="file"
            #fileInput
            (change)="onFileSelected($event, fileInput)"
            multiple
            style="display: none"
          />
        </div>
      </div>
    </div>
    <br />
    <div class="row" formArrayName="attachments">
      <div class="col-md-12">
        <div
          *ngFor="let item of filesArray.controls; let i = index"
          class="col-md-12 form-group file-display-container"
        >
          <div
            class="file-details d-flex justify-content-between align-items-center"
          >
            <span>{{ item.value?.file?.name }}</span>
            <button type="button" class="btn-remove" (click)="removeFile(i)">
              <i class="skillgro-bin"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
  <br />

  <form
    novalidate
    (ngSubmit)="onSubmitContent()"
    [formGroup]="contactForm"
    class="form-horizontal"
  >
    <div class="row">
      <div class="col-md-3">
        <label for="contactType"
          >Contact Type <span class="text-danger">*</span></label
        >
        <div
          class="form-group"
          [ngClass]="{
            'has-error': !cf['contactType'].valid && submittedContent,
          }"
        >
          <select
            class="form-control form-select"
            formControlName="contactType"
          >
            <option value="">-Select-</option>
            <option
              [value]="item.id"
              *ngFor="let item of addressAndContactTypes"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-3">
        <label class="inline">Contact Name <a class="required">*</a> </label>
        <div
          class="form-group"
          [ngClass]="{
            'has-error': !cf['contactName'].valid && submittedContent,
          }"
        >
          <input
            type="text"
            class="form-control"
            formControlName="contactName"
          />
        </div>
      </div>
      <div class="col-md-3">
        <label class="inline">Phone Number <a class="required">*</a> </label>
        <div
          class="form-group"
          [ngClass]="{ 'has-error': !cf['phone'].valid && submittedContent }"
        >
          <input
            type="text"
            mask="000-000-0000"
            class="form-control"
            formControlName="phone"
          />
        </div>
      </div>
      <div class="col-md-3">
        <label class="inline">Email Address <a class="required">*</a> </label>
        <div
          class="form-group"
          [ngClass]="{
            'has-error': !cf['emailAddress'].valid && submittedContent,
          }"
        >
          <input
            type="email"
            class="form-control"
            formControlName="emailAddress"
          />
        </div>
      </div>
      <div class="col-md-3 d-flex align-items-center">
        <div class="form-group new">
          <input type="submit" class="post-tag" value="Add" />
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div
        class="col-md-6"
        *ngFor="let c of Contacts; let i = index"
        [hidden]="c.isDeleted"
      >
        <div class="blog__post-item shine__animate-item">
          <div class="blog__post-content">
            <div class="blog__post-meta">
              <a
                type="button"
                class="card-header btn-remove"
                (click)="removeContent(i)"
              >
                <i class="fa fa-times"></i>
              </a>
              <ul class="list-wrap">
                <li>
                  <a><i class="fa fa-user"></i> : {{ c.contactName }}</a>
                </li>
                <li>
                  <a
                    ><i class="fa fa-cog"></i> :
                    {{ vendorAddressAndContactType[c.contactType] || "" }}</a
                  >
                </li>
                <li>
                  <a
                    ><i class="fa fa-phone"></i> :
                    {{ c.phone | mask: "000-000-0000" }}</a
                  >
                </li>
                <li>
                  <a href="mailto:{{ c.emailAddress }}">
                    <i class="fa fa-paper-plane"></i> : {{ c.emailAddress }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div class="col-md-12">
    <!-- The embed builds its controls once from dynamicFormValues, so wait for the vendor record. -->
    <app-dynamic-form-embed
      *ngIf="item.id"
      [id]="id"
      [clientId]="clientId"
      [sourceId]="sourceId"
      [form]="form"
      [submitted]="submitted"
      [diableInputFile]="!isEditing"
      [dynamicFormValues]="item.additionalFieldValues"
      (FormEmbeded)="integrateAdditionalFields($event)"
      (onDynamicFormFileChange)="onDynamicformFileChange($event)"
    >
    </app-dynamic-form-embed>
  </div>
  <div>
    <span class="text-danger">* Denotes Required Field</span>
    <div class="col-12 d-flex align-items-center" *ngIf="canSubmit">
      <button
        type="button"
        class="btn btn-primary"
        style="margin-right: 10px"
        (click)="onSubmit()"
      >
        Submit
      </button>
      <button type="button" class="btn btn-reset" (click)="resetForm()">
        Reset
      </button>
    </div>
  </div>
  <br />
</div>
<br />
